import React from 'react';
import './index.scss';
import defaultSrc from '@/pages/aigc/assets/svg/default-file-icon.svg';
import ImagePreview from '@/pages/aigc/components/ImagePreview';
import { UPLOAD_FILE_IMG_TYPE_LIST } from '../../../config/constant';
import FileItem from '../../../components/ImgUploadRenderList/FileItem';

const FileList = (props: {dataList: { id: string; fileSrc: string; previewName:string; }[];}) => {
  const {
    dataList,
  } = props;
  // chart 类 file part 仅用于 edit/refresh 时回传后端，不参与历史会话渲染
  const visibleList = (dataList || []).filter((item: any) => item?.file?.mimeType !== 'chart');

  return (
    <>
      {
        visibleList?.length > 0 && <div className='dba-question-img-list  dba-file-item-box '>
          {
            visibleList?.map((item, index: number) => <span key={index}>
              {UPLOAD_FILE_IMG_TYPE_LIST.includes(item.type) ? (
                <ImagePreview
                  src={item.fileSrc}
                  name={item?.previewName || ''}
                  defaultSrc={defaultSrc}
                  haveLoading={true}
                /> 
              ) : (
                <FileItem
                  file={{ ...item}}
                />
              )}
            </span>)
          }
        </div>
      }
    </>

  );
};

FileList.displayName = 'FileList';

export default FileList;
